import { LinearProgress, Box } from "@mui/material";
import PropTypes from "prop-types";
import { alpha, useTheme } from "@mui/material/styles";
import { brand } from "../theme/theme";

/** `soft`: data bars (metrics, rankings) in a faded brand gradient so many in a row don't shout. */
export const Progress = ({ value, soft = false, height = 8, sx = {}, ...props }) => {
  const theme = useTheme();
  return (
    <Box sx={{ width: "100%", ...sx }}>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height,
          borderRadius: 9999,
          backgroundColor: soft ? alpha(theme.palette.primary.main, 0.06) : theme.palette.divider,
          "& .MuiLinearProgress-bar": {
            background: soft
              ? `linear-gradient(90deg, ${alpha(theme.palette.primary.main, 0.45)} 0%, ${alpha(brand.orange, 0.45)} 100%)`
              : brand.gradient,
            borderRadius: 9999,
          },
        }}
        {...props}
      />
    </Box>
  );
};

Progress.propTypes = {
  value: PropTypes.number.isRequired,
  soft: PropTypes.bool,
  height: PropTypes.number,
  sx: PropTypes.object,
};
